export const colors = {
  main: '#009eac',
  white: '#FFF',
  grey1: '#FAFAFA',
  grey2: '#D9D9D9',
  grey3: '#B9B9B9',
  grey4: '#6D7278',
  success: '#52c41a',
  warning: '#faad14',
  error: '#f5222d',
}
